export default __webpack_public_path__ + "static/media/abra.c771da3b.png";